import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';
import pt from './locales/pt.json';

// El path manda: /en* → en, /pt* → pt, cualquier otra cosa → es.
// El built-in path detector devuelve '' para "/" y cae al cache de localStorage,
// que puede tener `en` de una visita previa — eso hacía que al volver a ES
// el idioma quedara en EN.
const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'langPrefix',
  lookup() {
    if (typeof window === 'undefined') return undefined;
    const m = window.location.pathname.match(/^\/(en|pt)(\/|$)/);
    return m ? m[1] : 'es';
  },
  cacheUserLanguage() {},
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
    },
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['langPrefix'],
      caches: [],
    },
    supportedLngs: ['es', 'en', 'pt'],
    nonExplicitSupportedLngs: true,
  });

// Sync <html lang> with active language so Chrome auto-translate works correctly
const syncHtmlLang = (lng) => {
  document.documentElement.lang = lng;
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
